export const CHALLENGES = 'challenges';
export const ACHIEVEMENTS = 'achievements';
